import { FC, useEffect, useState } from "react";

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { FormControl, IconButton, MenuItem, Select, Stack, TextField } from "@mui/material";

import ArrayPropertyComponent from "./Array/ArrayPropertyComponent";
import { ConfigPropertyModel, PropertyModel } from "./EditMobileConfig";

interface PropertyComponentProps {
    property: PropertyModel;
    configProperties: ConfigPropertyModel[];
    configNames: string[];
    remove: (prop: PropertyModel) => void;
}

const PropertyComponent: FC<PropertyComponentProps> = ({ property, configProperties, configNames, remove }) => {
    const [selectedConfigName, setSelectedConfigName] = useState<string>("");
    const [configType, setConfigType] = useState<string>("");
    const [configExampleValues, setConfigExampleValues] = useState<string[] | null>(null)
    const [configValue, setConfigValue] = useState<string | string[] | null>(null);

    useEffect(() => {

    }, [property])

    function SetSelectedConfigName(event: any) {
        var value = event.target.value;
        setSelectedConfigName(value);
        property.propertyName = value;

        // set type
        for (let i = 0; i < configProperties.length; i++) {
            if (configProperties[i].name === value) {
                setConfigType(configProperties[i].type);

                if (configProperties[i].type === "field") {
                    setConfigValue("");
                }
                else if (configProperties[i].type === "dropdown") {
                    setConfigExampleValues(configProperties[i].values ?? [])
                    setConfigValue("");
                }
                else if (configProperties[i].type === "array") {
                    setConfigValue([]);
                }

                break;
            }
        }
    }

    function SetConfigValueText(event: any) {
        var value: string = event.target.value;
        setConfigValue(value);
        property.propertyValue = value;
    }

    function SetConfigValueDropDown(event: any) {
        var value: string = event.target.value;
        setConfigValue(value);
        property.propertyValue = value;
    }

    function SetConfigValueArray(value: string[]) {
        setConfigValue(value);
        property.propertyValue = JSON.stringify(value);
    }

    return (
        <Stack direction={"row"}>
            {/* Database names */}
            <Stack
                direction={"row"}
                alignItems={"start"}>
                <p style={{ width: '70px', marginTop: "10px" }}>Property: </p>
                <FormControl sx={{ width: "230px" }}>
                    <Select
                        value={selectedConfigName}
                        onChange={SetSelectedConfigName}
                        size="small"
                        defaultValue={""}>
                        {configNames.map((name, index) =>
                            <MenuItem
                                key={index}
                                value={name}>
                                {name}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
            </Stack>
            {/* Types */}
            {configType === "" ? null : null}
            {configType === "field" ?
                <TextField
                    value={configValue}
                    onChange={SetConfigValueText}
                    sx={{ width: "245px", marginLeft: "10px" }}
                    size="small" />
                : null}
            {configType === "dropdown" ?
                <FormControl sx={{ minWidth: "245px", marginLeft: "10px" }}>
                    <Select
                        value={configValue}
                        onChange={SetConfigValueDropDown}
                        size="small">
                        {(configExampleValues ?? []).map((exampleValue, index) =>
                            <MenuItem
                                key={index}
                                value={exampleValue}>
                                {exampleValue}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
                : null}
            {configType === "array" ?
                <ArrayPropertyComponent
                    array={((configValue ?? []) as string[])}
                    changeArray={SetConfigValueArray} />
                : null}

            <IconButton
                color="error"
                size="large"
                sx={{ width: "30px", height: "30px", left: "10px", top: "5px" }}
                onClick={() => { remove(property) }}>
                <DeleteForeverIcon />
            </IconButton>
        </Stack>
    )
}

export default PropertyComponent;